(function(){
  if(window.__cctvLightboxInit)return;
  var lb = document.querySelector('[data-cctv-lb]');
  if (!lb) return;
  window.__cctvLightboxInit=true;
  var img = lb.querySelector('.cctv-lb__img');
  function open(src){ if (!src) return; img.setAttribute('src', src); lb.classList.add('is-open'); lb.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
  function close(){ lb.classList.remove('is-open'); lb.setAttribute('hidden', ''); img.setAttribute('src', ''); document.body.style.overflow = ''; }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.js-crc-zoom');
    if (btn){ e.preventDefault(); open(btn.getAttribute('data-img')); return; }
    if (lb.classList.contains('is-open') && lb.contains(e.target)){ close(); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
})();
